import PropTypes from "prop-types";
import { memo } from "react";
import { FormattedMessage, FormattedPlural } from "react-intl";
import "./DurationLabel.scss";

const DurationLabel = ({ duration, prefix }) => {
	return (
		duration > 0 && (
			<div className="duration-label" data-testid="duration-label">
				{prefix && <span className="duration-label__prefix">{prefix}</span>}
				<FormattedPlural
					value={duration}
					one={
						<FormattedMessage
							values={{
								duration: duration,
							}}
							id="general.duration.singular"
						/>
					}
					other={
						<FormattedMessage
							values={{
								duration: duration,
							}}
							id="general.duration.plural"
						/>
					}
				/>
			</div>
		)
	);
};

DurationLabel.propTypes = {
	duration: PropTypes.number,
	prefix: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
};

export default memo(DurationLabel);
